import React, { Component } from "react";
import notFoundLogo from "../images/404.png";

class NotFound extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-6 offset-md-3" style={{ margin: "30vh auto" }}>
          <img src={notFoundLogo} />
        </div>
      </div>
    );
  }
}

export default NotFound;
